module.exports = __webpack_public_path__ + "img/03mazda-cx50-angle.f217eae7.png";